import { Controller } from "@hotwired/stimulus"

// Input de OTP segmentado (6 casillas). Sincroniza el código completo en el campo
// oculto `otp` y auto-envía el form al completar los 6 dígitos. Va en el <form>.
// Casillas: data-otp-input-target="box"; oculto: data-otp-input-target="hidden".
// Las casillas NO llevan maxlength: un código pegado o autocompletado puede llegar como
// evento `input` (chip del teclado móvil, one-time-code) y maxlength lo truncaría a un
// dígito antes de que el JS lo vea; acá se reparte entre las casillas.
export default class extends Controller {
  static targets = ["box", "hidden"]

  connect() {
    this.boxTargets[0]?.focus()
  }

  // Solo dígitos. Un dígito avanza a la casilla siguiente; varios (pegado o autofill
  // que llegó como input) se reparten igual que en paste().
  input(event) {
    const box = event.target
    const inserted = (event.data ?? box.value).replace(/\D/g, "")
    if (inserted.length > 1) {
      this.distribute(inserted, this.index(box))
      return
    }
    box.value = box.value.replace(/\D/g, "").slice(-1)
    if (box.value) this.boxTargets[this.index(box) + 1]?.focus()
    this.sync()
  }

  // Backspace en casilla vacía → retrocede y borra; flechas para navegar.
  keydown(event) {
    const i = this.index(event.target)
    if (event.key === "Backspace" && !event.target.value) {
      const prev = this.boxTargets[i - 1]
      if (prev) {
        prev.focus()
        prev.value = ""
        this.sync()
        event.preventDefault()
      }
    } else if (event.key === "ArrowLeft") {
      this.boxTargets[i - 1]?.focus()
    } else if (event.key === "ArrowRight") {
      this.boxTargets[i + 1]?.focus()
    }
  }

  // Pegar reparte los dígitos del portapapeles entre las casillas.
  paste(event) {
    event.preventDefault()
    const digits = (event.clipboardData?.getData("text") || "").replace(/\D/g, "")
    this.distribute(digits, this.index(event.target))
  }

  index(box) {
    return this.boxTargets.indexOf(box)
  }

  // Un código completo rellena desde la primera casilla; uno parcial, desde la casilla
  // donde cayó. Luego enfoca la primera vacía y sincroniza (auto-envío si quedó completo).
  distribute(digits, start) {
    const boxes = this.boxTargets
    const from = digits.length >= boxes.length ? 0 : Math.max(start, 0)
    digits.slice(0, boxes.length - from).split("").forEach((d, i) => { boxes[from + i].value = d })
    const nextEmpty = boxes.find((b) => !b.value) || boxes.at(-1)
    nextEmpty?.focus()
    this.sync()
  }

  // Concentra el código en el hidden y auto-envía al completar.
  sync() {
    const code = this.boxTargets.map((b) => b.value).join("")
    this.hiddenTarget.value = code
    if (code.length === this.boxTargets.length) this.element.requestSubmit()
  }
}
